import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import QueryDropdown from '../../components/connectedForm/QueryDropdown';
import Supplier from '../../graphql/entities/supplier/Supplier';
import { Button, SuccessButton } from '../connectedForm/Button';
import getClientMutationId from '../../utils/getClientMutationId';
import PurchaseRequirementMigrateSupplier from '../../graphql/mutations/purchases/PurchaseRequirementMigrateSupplier.graphql';
import { useComponentQueryErrorHandling } from '../../utils/parseErrorResponse';
import { serviceActions } from '../../state/modules/service';
import { ApolloCache, useMutation } from '@apollo/client';
import WorkspaceContext from '../Context/WorkspaceContext';
import normalizeVariables from '../../graphql/schema/normalizeVariables';
import {
  AlertType,
  IPurchaseRequirementMigrateSupplierMutationResult,
  IPurchaseRequirementMigrateSupplierMutationVariables,
} from '../../graphql/schema/p4types';
import { useActionProps } from '../../utils/useActionProps';
import { ModalBottomButtonContainer } from './Styles';
import { BasicHeader } from '../../actions/BasicHeader';
import FluentModal from './FluentModal';

const MigrateShortageSupplierModal = ({ onClose, modalOpen }: { onClose: () => void; modalOpen: boolean }) => {
  const dispatch = useDispatch();
  const [supplier, setSupplier] = useState(null);
  const { reloadData } = useContext(WorkspaceContext);
  const handleQueryError = useComponentQueryErrorHandling();
  const [migrateSupplier] = useMutation<
    IPurchaseRequirementMigrateSupplierMutationResult,
    IPurchaseRequirementMigrateSupplierMutationVariables
  >(PurchaseRequirementMigrateSupplier, {
    onCompleted: () => {
      dispatch(serviceActions.genericAlert('Supplier Migration', 'Shortages migrated successfully', AlertType.Success));
      reloadData();
    },
    onError: handleQueryError,
    update: (cache: ApolloCache<any>, result) => {
      cache.modify({
        fields: {
          purchaseRequirements: () => {
            //Wipe out the cache for purchase requirements to force it to properly refetch - Otherwise getting a bad merge.
            return undefined;
          },
        },
      });
    },
  });

  const actionProps = useActionProps('purchaseRequirementDetails');

  const migrate = () => {
    const input = normalizeVariables({
      clientMutationId: getClientMutationId(),
      supplier: supplier,
      filters: actionProps.filters,
      purchaseRequirementDetails: actionProps.purchaseRequirementDetails || [],
      include: actionProps.include,
    });

    migrateSupplier({ variables: { input } }).then();

    onClose();
  };

  return (
    <FluentModal isOpen={modalOpen} styles={{ main: { minWidth: '500px', paddingBottom: '60px' } }}>
      <BasicHeader>Migrate Supplier</BasicHeader>
      <div style={{ padding: '1em' }}>
        <QueryDropdown
          {...Supplier.dropdown}
          label="Supplier"
          onChange={setSupplier}
          value={supplier}
          data-testid="migrate-supplier"
        />
      </div>
      <ModalBottomButtonContainer>
        <Button onClick={onClose}>Cancel</Button>
        <SuccessButton onClick={migrate}>Confirm</SuccessButton>
      </ModalBottomButtonContainer>
    </FluentModal>
  );
};

export default MigrateShortageSupplierModal;
